// frontend/api/license.js
import axios from "axios";
import { getApiUrl } from "../config/api";

const API_BASE = getApiUrl();

export const getLmsUserId = async (email) => {
  try {
    const response = await axios.post(
      `${API_BASE}/api/payment/get-lms-user-id`,
      { email },
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    return response.data.lms_user_id;
  } catch (error) {
    console.error('Error getting lms_user_id:', error);
    throw error;
  }
};